export const INDEX_ROUTE = '/';
export const OLD_CHATS_ROUTE = '/chats/:threadId';
export const CHATS_ROUTE = '/chats';
export const COMPANY_PROFILE_ROUTE = '/company/:companyProfileId';
export const COMPANY_PUBLIC_PROFILE_ROUTE = '/company/:companyProfileId/profile';
export const COMPANY_REVIEWS_ROUTE = '/company/:companyProfileId/reviews';
export const COMPANY_PROFILE_OLD_ROUTE = '/company';
export const PROFILE_ROUTE = '/profile';

export const FUNNEL_MAIN = '/funnels/:openingId';
export const FUNNEL_REVIEW_ROUTE = '/funnels/:openingId/review';
export const FUNNEL_PREVIEW_ROUTE = '/funnel/:openingId/preview';
export const FUNNEL_OVERVIEW_ROUTE = '/funnel/:openingId/overview';
export const FUNNEL_ROUTE = '/funnel/:openingId';
export const OLD_FUNNEL_ROUTE = '/funnels/:openingId';

export const NEW_FUNNEL_ROUTE = '/funnels/new';
export const FUNNEL_EDIT_ROUTE = '/funnels/:openingId/edit';
export const FUNNEL_MESSAGE_ROUTE = '/funnels/:openingId/edit/message';
export const FUNNEL_APPLICATIONS_ROUTE = '/funnels/:openingId/edit/questions';
export const FUNNEL_PITCH_ROUTE = '/funnels/:openingId/edit/pitch';
export const FUNNEL_EXPORT_ROUTE = '/export/funnels/:openingId';

export const PUBLISHED_OPENING_APPLICANTS = '/published-opening-applicants/:openingId';

export const OPENINGS_ROUTE = '/openings';
export const AGENCY_ROUTE = '/agency';
export const OPENING_ROUTE = '/opening/:openingId';

export const TALENT_ACTIVITY_ROUTE = '/talent-activity';
export const ACTIVITY_ROUTE = '/activity';
export const INSIGHTS_ACTIVITY_ROUTE = '/insights/activity';
export const INSIGHTS_MARKET_OVERVIEW_ROUTE = '/insights/market-overview';
export const SETTINGS_ROUTE = '/settings';
export const SETTINGS_BILLING_ROUTE = '/settings/billing';
export const SETTINGS_COMPANY_INFORMATION_ROUTE = '/settings/company-information';
export const SETTINGS_TEAM_ROUTE = '/settings/team';
export const SETTINGS_SECURITY = '/settings/security';
export const SOURCE_ROUTE = '/source';
export const PIPELINE_TALENTS_ROUTE = '/pipeline-talents';
export const FEATURED_APPLICANTS_ROUTE = '/featured-applicants';
export const PUBLIC_OPENINGS_ROUTE = '/public-openings';

export const REGISTER_ROUTE = '/register';
export const LOGIN_ROUTE = '/login';
export const RESET_PASSWORD_ROUTE = '/password';
export const FORGET_PASSWORD_ROUTE = '/password/new';

export const USER_PROFILE_ROUTE = '/profile';
export const USER_PROFILE_SECURITY_ROUTE = '/profile/password';

export const QUERY_PARAMS = {
  ACTIVATE_SUBSCRIPTION: {
    key: 'globalModal',
    value: 'activate-subscription',
  },
};
